import { render, staticRenderFns } from "./VenueCampaignDangerZone.vue?vue&type=template&id=54fb8f5f&"
import script from "./VenueCampaignDangerZone.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignDangerZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports